<script lang="ts">
	// Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Services and configs
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import { isWallDisplay } from 'src/helpers/interface_helpers';
	import {
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';

	// Components
	import ControlSwitch from 'src/components/Controls/Single/ControlSwitch.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import RelayAdvancedView from './RelayAdvancedView.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';
	import DeviceLabelList from '../DeviceLabelList.svelte';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: isMainWallDisplay = isWallDisplay(device?.type) && device?.category === 'relay';
	$: isThermostatEnabled = isMainWallDisplay
		? typeof settings?.['thermostat:0'] !== 'undefined'
		: false;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
</script>

{#if isThermostatEnabled}
	<RelayAdvancedView {device} />
{:else}
	<DeviceViewStateWrapper {device}>
		<div slot="staticTop">
			<DeviceLabelList {labelList} />
			<DeviceNotificationLabel deviceId={device?.id} />
		</div>
		<div class="flex-full-height align-items-center justify-content-center" slot="content">
			<ControlSwitch {device} {status} {settings} isWide />
		</div>
	</DeviceViewStateWrapper>
{/if}
